import React from 'react'
import { Skeleton } from 'antd'

interface propsModel {
  active?: boolean;
}
export const LoadingPage = (props: propsModel) => {
  return (
    <div className="container pt-5">
      <Skeleton active />
    </div>
  )
}